import $ from 'jquery'

export default gradYearFunc => {
  let GradYear = $('select[name=graduate_year]')
  let GradOptions = ''
  let y = new Date().getFullYear()
  for (let i = y; i <= y + 6; i++) {
    GradOptions += `<option value=${i}>${i}</option>`
  }
  GradYear[0].innerHTML = GradOptions
}



// WEBPACK FOOTER //
// ./src/assets/js/gradYear.js